import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { AUTH_BASE_PATH } from '@/config/baseModulesLink.tsx';
import { AuthRoutes } from '@/modules/Auth/AuthRoutes.tsx';

export const ProjectUnAuthorisedRoutes = createBrowserRouter([
  {
    element: <Outlet />,
    path: AUTH_BASE_PATH,
    children: AuthRoutes,
  },
  {
    element: <Navigate to={AUTH_BASE_PATH} />,
    path: '*',
  },
]);
